module.exports = __webpack_public_path__ + "static/structure-3d-pyramide-louvre-c5590ac5e1becca7b973be16092ce03c.png";